// Localidades por municipio para los partidos del Colegio
// Para estos municipios, las localidades son obligatorias y predefinidas
export const LOCALIDADES_POR_MUNICIPIO = {
  "Lomas de Zamora": [
    "Banfield",
    "Llavallol",
    "Lomas de Zamora",
    "Temperley",
    "Turdera",
    "Villa Centenario",
    "Villa Fiorito",
    "Otro"
  ],
  "Lanús": [
    "Gerli",
    "Lanús Este",
    "Lanús Oeste",
    "Monte Chingolo",
    "Remedios de Escalada",
    "Valentín Alsina",
    "Otro"
  ],
  "Avellaneda": [
    "Avellaneda",
    "Crucecita",
    "Dock Sud",
    "Gerli",
    "Piñeyro",
    "Sarandí",
    "Villa Domínico",
    "Wilde",
    "Otro"
  ],
  "Almirante Brown": [
    "Adrogué",
    "Burzaco",
    "Claypole",
    "Don Orione",
    "Glew",
    "José Mármol",
    "Longchamps",
    "Malvinas Argentinas",
    "Ministro Rivadavia",
    "Rafael Calzada",
    "San Francisco Solano",
    "San José",
    "Otro"
  ],
  "Esteban Echeverría": [
    "9 de Abril",
    "Canning",
    "El Jagüel",
    "Luis Guillón",
    "Monte Grande",
    "Otro"
  ],
  "Ezeiza": [
    "Canning",
    "Carlos Spegazzini",
    "Ezeiza",
    "La Unión",
    "Tristán Suárez",
    "Otro"
  ]
};

// Lista de municipios que tienen localidades predefinidas (pertenecen al Colegio)
export const MUNICIPIOS_CON_LOCALIDADES = Object.keys(LOCALIDADES_POR_MUNICIPIO);

// Lista completa de municipios
export const MUNICIPIOS = [
  "Lomas de Zamora", 
  "Lanús", 
  "Avellaneda", 
  "Almirante Brown", 
  "Esteban Echeverría", 
  "Ezeiza", 
  "Presidente Perón", 
  "Quilmes", 
  "CABA", 
  "La Plata", 
  "San Vicente", 
  "Cañuelas", 
  "Otro"
];

// Áreas de trabajo/intervención
export const AREAS_TRABAJO = [
  "Salud", 
  "Desarrollo Social", 
  "Educación", 
  "Discapacidad",
  "Hábitat y Ambiente", 
  "Niñez y Adolescencia", 
  "Géneros y Diversidad",
  "Justicia", 
  "Serv. Penitenciario", 
  "Patronato Liberados", 
  "Hábitat", 
  "Investigación"
];

// Tipos de institución
export const TIPOS_INSTITUCION = [
  "Administración Pública Nacional",
  "Administración Pública Provincial",
  "Administración Pública Municipal",
  "Organización de la Sociedad Civil (ONG)",
  "Ámbito privado"
];

// Colores para badges de áreas
export const AREA_COLORS = {
  "Salud": "bg-red-100 text-red-700",
  "Desarrollo Social": "bg-blue-100 text-blue-700",
  "Educación": "bg-yellow-100 text-yellow-700",
  "Discapacidad": "bg-purple-100 text-purple-700",
  "Hábitat y Ambiente": "bg-green-100 text-green-700",
  "Niñez y Adolescencia": "bg-pink-100 text-pink-700",
  "Géneros y Diversidad": "bg-violet-100 text-violet-700",
  "Justicia": "bg-indigo-100 text-indigo-700",
  "Serv. Penitenciario": "bg-gray-100 text-gray-700",
  "Patronato Liberados": "bg-orange-100 text-orange-700",
  "Hábitat": "bg-teal-100 text-teal-700",
  "Investigación": "bg-cyan-100 text-cyan-700"
};

// Estados de institución
export const ESTADO_CONFIG = {
  activa: { label: "Activa", color: "bg-green-100 text-green-700", icon: "CheckCircle" },
  dudosa: { label: "Info. dudosa", color: "bg-yellow-100 text-yellow-700", icon: "AlertTriangle" },
  cerrada: { label: "Cerrada/Mudada", color: "bg-red-100 text-red-700", icon: "XCircle" }
};

// Función helper para verificar si un municipio tiene localidades predefinidas
export const tieneLocalidadesPredefinidas = (municipio) => {
  return MUNICIPIOS_CON_LOCALIDADES.includes(municipio);
};

// Función helper para obtener localidades de un municipio
export const getLocalidades = (municipio) => {
  return LOCALIDADES_POR_MUNICIPIO[municipio] || [];
};
